<div *ngIf="entity && form && languages && roles" editorType="large">
  <form [formGroup]="form">
    <div class="column">

      <dx-text-area formControlName="name" formField [label]="'common.name' | translate | ucfirst"
        [value]="entity.name"></dx-text-area>

      <dx-text-area formControlName="surname" formField [value]="entity.surname"></dx-text-area>

      <dx-text-area #userName formControlName="userName" formField required minlength="3" [value]="entity.userName"
        [readOnly]=true>
      </dx-text-area>

      <dx-select-box formControlName="roleId" formField required [items]="roles" displayExpr="name" valueExpr="id"
        labelMode="floating" [readOnly]="true" [label]="'common.profile' | translate | ucfirst" [value]="entity.roleId">
        <dx-validator>
          <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
        </dx-validator>
      </dx-select-box>

      <dx-text-area #email formControlName="email" formField required email mode="email"
        [label]="'common.email' | translate | ucfirst" [value]="entity.email"></dx-text-area>
      <dx-text-box formControlName="phoneNumber" formField mode="tel"></dx-text-box>

      <dx-select-box formControlName="languageId" formField required [dataSource]="languages" displayExpr="name"
        valueExpr="id" [searchExpr]="['name']" (onValueChanged)="onLanguageValueChanged($event)" />

      <dx-select-box formControlName="notificationTypeId" formField required [items]="notificationTypes"
        displayExpr="name" valueExpr="id"></dx-select-box>

      <dx-select-box formControlName="synchronizationCalendarId" formField [items]="synchronizationCalendars"
        displayExpr="calendarName" valueExpr="calendarId" [searchExpr]="['calendarName']"></dx-select-box>
    </div>
    <dx-load-panel [position]="{ of: '#formContainer' }" [(visible)]="busy" [showIndicator]="true" [showPane]="true"
      [shading]="true">{{ this.processingText }}</dx-load-panel>
  </form>

  <div *ngIf="worker" class="controls h-full">
    <dx-tab-panel (onOptionChanged)="onTabChanged($event)" class="h-full">
      <dxi-item [title]="'entity.calendar.calendar' | translate | ucfirst" class="tabs-content">
        <div class="h-full flex flex-col">
          <gs-worker-calendar [worker]="worker" [readonly]="true" />
        </div>
      </dxi-item>
      <dxi-item [title]="'entity.floatingHoliday.title' | translate | ucfirst" class="tabs-content">
        <div class="h-full flex flex-col">
          <dx-data-grid class="flex-1" [glamResource]="floatingHolidaysRes" [disabledAdd]="true"
            [disabledDelete]="true">
            <dxi-column dataType="number" dataField="exercise" [allowEditing]="false"
              [caption]="'entity.floatingHoliday.exercise' | translate | ucfirst">
            </dxi-column>
            <dxi-column dataType="number" dataField="editedDays"
              [caption]="'entity.floatingHoliday.days' | translate | ucfirst">
            </dxi-column>
            <dxi-column dataType="number" dataField="pendingDays" [allowEditing]="false"
              [caption]="'entity.floatingHoliday.pendingDays' | translate | ucfirst">
            </dxi-column>
          </dx-data-grid>
        </div>
      </dxi-item>
      <dxi-item [title]="'entity.scheduleAdjustmentRequest.title' | translate | ucfirst" class="tabs-content">
        <div class="h-full flex flex-col">
          <dx-data-grid class="flex-1" [glamResource]="scheduleAdjustmentRequestsRes"
            [createComponent]="addRequestComponent" [customParams]="{workerId: this.api.auth.userValue!.workerId}">
            <dxi-column dataType="date" dataField="startDate"
              [caption]="'entity.scheduleAdjustmentRequest.startDate' | translate | ucfirst">
            </dxi-column>
            <dxi-column dataType="date" dataField="endDate"
              [caption]="'entity.scheduleAdjustmentRequest.endDate' | translate | ucfirst">
            </dxi-column>
            <dxi-column dataType="string" dataField="comments"
              [caption]="'entity.scheduleAdjustmentRequest.comments' | translate | ucfirst">
            </dxi-column>
            <dxi-column [allowEditing]="false" dataType="number" dataField="stateId" editCellTemplate="editStateValue"
              [caption]="'entity.scheduleAdjustmentRequest.stateId' | translate | ucfirst" cellTemplate="stateCellTpl">
              <div *dxTemplate="let cell of 'stateCellTpl'" class="flex justify-center items-center w-full min-h-full">
                <gs-entity-state-label [entity]="cell.data" [fieldName]="cell.column.dataField"
                  [resource]="$any(scheduleAdjustmentRequestsRes!)" />
              </div>
            </dxi-column>
          </dx-data-grid>
        </div>
      </dxi-item>
      <dxi-item [title]="'entity.workerExpenses.title' | translate | ucfirst" class="tabs-content">
        <div class="h-full flex flex-col">
          <dx-data-grid class="flex-1" [glamResource]="workerExpensesRes"
            [createComponent]="addWorkerExpenseComponent" [customParams]="{workerId: this.api.auth.userValue!.workerId}"
            (onInitialized)="onWorkerExpensesGridInitialized($event)"
            (onEditorPreparing)="onWorkerExpensesEditorPreparing($event)">
            <dxi-column [allowEditing]="false" dataType="date" dataField="date"
              [caption]="'entity.workerExpenses.date' | translate | ucfirst">
            </dxi-column>
            <dxi-column dataField="expenseTypeId" [setCellValue]="setWorkerExpenseType"
              [caption]="'entity.workerExpenses.expenseType' | translate | ucfirst">
              <dxo-lookup [dataSource]="expenseTypes" displayExpr="name" valueExpr="id"></dxo-lookup>
            </dxi-column>
            <dxi-column dataType="number" dataField="quantity"
              [caption]="'entity.workerExpenses.quantity' | translate | ucfirst">
            </dxi-column>
            <dxi-column dataType="number" dataField="unitPrice" cellTemplate="currency"
              [caption]="'entity.workerExpenses.unitPrice' | translate | ucfirst">
              <div *dxTemplate="let item of 'currency'">
                {{ formatCurrency(item.value , this.langService!.code, this.currency!.currencySymbol, this.currency!.code, '.2-2')}}
              </div>
            </dxi-column>
            <dxi-column dataType="number" dataField="amount" cellTemplate="currency" [allowEditing]="false"
              [caption]="'entity.workerExpenses.amount' | translate | ucfirst">
              <div *dxTemplate="let item of 'currency'">
                {{ formatCurrency(item.value , this.langService!.code, this.currency!.currencySymbol, this.currency!.code, '.2-2')}}
              </div>
            </dxi-column>
            <dxi-column [allowEditing]="false" dataType="string" dataField="productionOrderCode"
              [caption]="'entity.workerExpenses.productionOrderCode' | translate | ucfirst">
            </dxi-column>
            <dxi-column [allowEditing]="false" dataType="string" dataField="organizationLegalName"
            [caption]="'entity.workerExpenses.organization' | translate | ucfirst">
            </dxi-column>
            <dxi-column [allowEditing]="false" dataType="number" dataField="stateId" editCellTemplate="editStateValue"
              [caption]="'entity.workerExpenses.state' | translate | ucfirst" cellTemplate="stateCellTpl">
              <div *dxTemplate="let cell of 'stateCellTpl'" class="flex justify-center items-center w-full min-h-full">
                <gs-entity-state-label [entity]="cell.data" [fieldName]="cell.column.dataField"
                  [resource]="$any(workerExpensesRes!)" />
              </div>
            </dxi-column>
          </dx-data-grid>
        </div>
      </dxi-item>
    </dx-tab-panel>
  </div>

</div>

<dx-popup *ngIf="showResetPassword" [visible]="true" [showCloseButton]="false" [showTitle]="false" width="auto"
  height="auto" (onHidden)="showResetPassword = false">
  <div *dxTemplate="let data of 'content'">
    <div class="flex justify-between pb-3 border-b">
      <div class="text-2xl font-bold">{{ 'common.changePassword' | translate | ucfirst }}</div>
      <dx-button icon="close" (onClick)="showResetPassword = false"></dx-button>
    </div>
    <app-user-change-password [user]="this.entity"
      (passwordChanged)="showResetPassword = false"></app-user-change-password>
  </div>
</dx-popup>